import { Box, Button, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
    useQueryAdminMonitoringGetOrganizationList,
    useRefreshOrganizationAlertById,
} from "src/api/admin-monitoring";
import { Loading } from "src/components/generics/loading/Loading";
import { useTranslation } from "src/design-system/core/TranslationContext";
import { PATH_SUPERADMIN_MONITORING } from "src/routesConstants";
import { useAdminMonitoringStyles } from "src/views/admin/AdminView/admin-monitoring/AdminMonitoring.style";
import {
    ADMIN_MONITORING_TK,
    ADMIN_MONITORING_TRANSLATION_NAMESPACE,
} from "src/views/admin/AdminView/admin-monitoring/config";

export function RefreshOrganizationMonitoring(): JSX.Element {
    const classes = useAdminMonitoringStyles();
    const [organizationId, setOrganizationId] = useState(undefined);
    const [disableButton, setDisabledButton] = useState(false);
    const { t } = useTranslation(
        `${ADMIN_MONITORING_TRANSLATION_NAMESPACE}:${ADMIN_MONITORING_TK}`
    );
    const history = useHistory();
    const { mutateAsync: refreshOrganizationAlertById } = useRefreshOrganizationAlertById(
        Number(organizationId)
    );
    const { refetch } = useQueryAdminMonitoringGetOrganizationList();
    const { enqueueSnackbar } = useSnackbar();

    const handleClickRefresh = async () => {
        if (organizationId && !Number.isNaN(organizationId)) {
            try {
                setDisabledButton(true);
                await refreshOrganizationAlertById(organizationId);
                await refetch();
                setDisabledButton(false);
                history.push(`${PATH_SUPERADMIN_MONITORING}/dashboard/${organizationId}`);
            } catch (err) {
                setDisabledButton(false);
                if (err.status === 412) {
                    enqueueSnackbar(t("orga-id-not-good"), { variant: "error" });
                } else {
                    enqueueSnackbar(t("refresh-not-good"), { variant: "error" });
                }
                console.error("err", err);
            }
        }
    };

    return (
        <>
            <Box className={classes.refreshOrganizationBox}>
                <h4 className={classes.refreshOrganizationTitle}>{t("explanation-refresh")}</h4>
                <TextField
                    value={organizationId}
                    onChange={(e) => setOrganizationId(e.target.value)}
                    className={classes.refreshOrganizationTextField}
                    variant="outlined"
                    type="number"
                    placeholder={t("orga-id")}
                />
                <Button
                    disabled={disableButton}
                    onClick={() => handleClickRefresh()}
                    className={classes.refreshOrganizationButton}
                    color="primary"
                    variant="outlined"
                >
                    {disableButton ? <Loading /> : t("submit")}
                </Button>
            </Box>
        </>
    );
}
